/**
 * The census creation application's own routes, mounted by the shell at /census.
 *
 * Nothing in here knows it sits at /census — the prefix is the shell's decision, recorded once
 * in `platform/registry.ts`.
 */
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const CensusesPage = lazy(() => import('@/apps/census/CensusesPage'));
const CensusNewPage = lazy(() => import('@/apps/census/CensusNewPage'));
const CensusDetailPage = lazy(() => import('@/apps/census/CensusDetailPage'));
const CensusTemplatesPage = lazy(() => import('@/apps/census/CensusTemplatesPage'));
const LayoutFormPage = lazy(() => import('@/apps/census/LayoutFormPage'));

export const censusRoutes = (
  <Route path="census">
    <Route index element={<CensusesPage />} />
    <Route path="new" element={<CensusNewPage />} />
    <Route path="templates" element={<CensusTemplatesPage />} />
    <Route path="templates/layouts/new" element={<LayoutFormPage />} />
    <Route path=":batchId" element={<CensusDetailPage />} />
  </Route>
);
